import { useEffect } from 'react';
import { useGlobalTheme } from '@trello/theme';
import type { UseDynamicTokensConfig } from './DynamicTokenConfig.types';
import { setDynamicTokens } from './setDynamicTokens';

export const useDynamicTokens = ({
  ref,
  ...config
}: UseDynamicTokensConfig) => {
  const { theme } = useGlobalTheme();

  useEffect(() => {
    if (!ref.current) {
      return;
    }
    setDynamicTokens({
      element: ref.current,
      theme,
      ...config,
    });
  }, [config, ref, theme]);
};
